import React, { useEffect } from "react";
import { Input, InputProps } from "reactstrap";
import { useTranslation } from "react-i18next";

import i18n from "../../i18n";
import { SelectListDto } from "../../models";
import { useGetGradeSelectListByCourseQuery } from "../../store/api/gradeApi";
import { toast } from "react-toastify";

type TProps = InputProps & {
  placeholder: string;
  courseId?: string;
};

export const GradeSelect: React.FC<TProps> = ({
  courseId,
  placeholder,
  ...props
}) => {
  const { t } = useTranslation();

  const { data, error } = useGetGradeSelectListByCourseQuery(courseId!, {
    skip: !courseId,
  });

  useEffect(() => {
    if (error) {
      const errMsg =
        "status" in error
          ? (error.data as any)?.message || "An error occurred"
          : "An error occurred";
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  return (
    <div className="input-group">
      <Input {...props}>
        <option value={""}>{t(placeholder)} </option>
        {data &&
          data.length &&
          data.map(({ id, value }: SelectListDto) => (
            <option value={id} key={id} className="text-capitalize">
              {i18n.language === "ar" ? value.ar : value.en}
            </option>
          ))}
      </Input>
    </div>
  );
};
